import styled from "styled-components";
import { Link } from "../../components/atoms/Link";
import { ExternalLinkIcon } from "../../components/atoms/ExternalLinkIcon";
import {
  applicantsGuide,
  assessorsHandbook,
  guidelines,
} from "../../lib/constants";

const Container = styled.div`
  display: block;
  font-weight: 300;
`;

function LandingPageHelp() {
  return (
    <Container>
      <p>
        The{" "}
        <Link href="User-guide.pdf" target="_blank" rel="noopener noreferrer">
          NVR Map User Guide
        </Link>
        <ExternalLinkIcon /> provides step-by-step instructions for using the
        Native Vegetation Removal and Offset Tools.
      </p>
      <p>
        Short tutorial videos can be accessed{" "}
        <Link
          href="https://www.environment.vic.gov.au/native-vegetation/NVRMap"
          target="_blank"
          title="Tutorial videos"
          rel="noopener noreferrer"
        >
          here
        </Link>
        <ExternalLinkIcon />.
      </p>
      <p>The following useful links are provided to support users:</p>
      <ul>
        <li>
          <Link
            href="https://www.environment.vic.gov.au/native-vegetation/native-vegetation-values"
            target="_blank"
            title="DEECA Native Vegetation Values website"
            rel="noopener noreferrer"
          >
            DEECA Native Vegetation Values website
          </Link>
          <ExternalLinkIcon />
        </li>
        <li>
          <Link
            href="https://www.environment.vic.gov.au/native-vegetation/native-vegetation-removal-regulations"
            target="_blank"
            title="DEECA Native Vegetation Regulation website"
            rel="noopener noreferrer"
          >
            DEECA Native Vegetation Regulation website
          </Link>
          <ExternalLinkIcon />
        </li>
        <li>
          <Link
            href={guidelines}
            target="_blank"
            title="Guidelines for the removal, destruction or lopping of native vegetation"
            rel="noopener noreferrer"
          >
            Guidelines for the removal, destruction or lopping of native
            vegetation
          </Link>
          <ExternalLinkIcon />
        </li>
        <li>
          <Link
            href={applicantsGuide}
            target="_blank"
            title="Applicant’s Guide"
            rel="noopener noreferrer"
          >
            Applicant’s Guide
          </Link>
          <ExternalLinkIcon />
        </li>
        <li>
          <Link
            href={assessorsHandbook}
            target="_blank"
            title="Assessor’s Handbook"
            rel="noopener noreferrer"
          >
            Assessor’s Handbook
          </Link>
          <ExternalLinkIcon />
        </li>
        <li>
          <Link
            href="https://nvcr.delwp.vic.gov.au/"
            target="_blank"
            title="Native Vegetation Credit Register Search Tool"
            rel="noopener noreferrer"
          >
            Native Vegetation Credit Register Search Tool
          </Link>
          <ExternalLinkIcon />
        </li>
      </ul>
    </Container>
  );
}

export default LandingPageHelp;
